import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuthStore } from "@/auth/store";

/**
 * Schützt Routen — wenn nicht eingeloggt, Redirect nach /login mit
 * `state.from`, damit wir nach erfolgreichem Login zurückspringen können.
 */
export function ProtectedRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isHydrating = useAuthStore((s) => s.isHydrating);
  const location = useLocation();

  if (isHydrating) {
    return <FullPageLoader />;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}

/**
 * Umgekehrter Guard — bereits Eingeloggte sollen nicht auf /login landen.
 */
export function GuestRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isHydrating = useAuthStore((s) => s.isHydrating);

  if (isHydrating) {
    return <FullPageLoader />;
  }
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}

/**
 * Admin-Bereich: nur ADMIN oder OWNER. MEMBER bekommt 403-Hint und Redirect.
 * Spiegelt das Backend require_admin_or_owner.
 */
export function AdminOrOwnerRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isHydrating = useAuthStore((s) => s.isHydrating);
  const user = useAuthStore((s) => s.user);

  if (isHydrating) {
    return <FullPageLoader />;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (user && user.role !== "admin" && user.role !== "owner") {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}

/**
 * Operator-Admin-only: nur globaler `UserRole.ADMIN` (kein Tenant gebunden).
 * Spiegelt das Backend `require_admin` — wird für Tenant- + User-Management
 * verwendet, die Owner explizit NICHT sehen dürfen.
 */
export function AdminOnlyRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isHydrating = useAuthStore((s) => s.isHydrating);
  const user = useAuthStore((s) => s.user);

  if (isHydrating) {
    return <FullPageLoader />;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (user && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}

function FullPageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    </div>
  );
}
